// extracted by mini-css-extract-plugin
module.exports = {"pictureContainer":"press-kit-module--pictureContainer--1PCAF","details":"press-kit-module--details--MCpnq"};